import { GraphItem as OldGraphItem } from 'graph/GraphItem';
import { GraphItem, isAggregatedGraphEdge } from '@ardoq/graph';
import { FieldValue } from 'graph/FieldValue';
import { isEntity } from '@ardoq/api-types';

export const dataModelId = (item: GraphItem | OldGraphItem): string => {
  if (isAggregatedGraphEdge(item)) {
    return item.modelIds[0];
  }

  if (item instanceof GraphItem) {
    return item.modelId;
  }

  if (isEntity(item.dataModel)) {
    return item.dataModel._id;
  }

  const backboneId = (item.dataModel as Backbone.Model).id;
  if (backboneId) {
    return backboneId;
  }

  const cid = (item.dataModel as Backbone.Model | FieldValue).cid;
  if (cid) {
    return cid;
  }

  return (item.dataModel as any).name();
};
